import { app } from '../../../../../app';
import { Controller } from './usb-add.controller';

app.component('addUsbTokens', {
    controller: Controller,
    templateUrl: require('./usb-add.html'),
});



// WEBPACK FOOTER //
// ./src/portal/states/company/hard-token-management/hard-token-add/usb-token-add/integrate-usb-token.component.js